<template>
    <PopupRouterView :showLeftIcon="true" label="Picking For Delivery Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="pickingfordelivery"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="pickingForDeliveryInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-delivery-instruction" ref="fieldset-delivery-instruction" :model.sync="inputQrCode" label="Delivery Instruction" @scannedMethod="scanDeliveryInstruction" :isBusy="isScanDeliveryInstructionLoading" :isFocus="isFocusScanDeliveryInstruction"/>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="vwDeliveryInstructions != null && vwDeliveryInstructions.length > 0">
							<app-list :isDataLoading="isVwDeliveryInstructionLoading"
								:dataCount="vwDeliveryInstructions.length">
								<delivery-instruction-item v-for="(item, index) in vwDeliveryInstructions" :model="item" :key="index"
									@nextAction="goToNextByDeliveryInstruction(2, item)" :isDisabled="checkIsVwDeliveryInstructionDisabled(item)" />
							</app-list>
						</span>

					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" label="Delivery Instruction number" :model="model.deliveryInstructionDiNumber" />
						<app-label label-cols-lg="12" size="sm" label="Delivery Date" :model="formattedDeliveryDate" />
						<app-input-scan id="fieldset-delivery-instruction-item" ref="fieldset-delivery-instruction-item" :model.sync="inputQrCodeDetail" label="Delivery Instruction Item" @scannedMethod="scanDeliveryInstructionItem" :isBusy="isScanDeliveryInstructionItemLoading" :isFocus="isFocusScanDeliveryInstructionItem"/>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<!-- {{ model.pickingForDeliveryDetail }} -->
						<!-- nanti pake vw detail -->
						<span v-if="vwPickingForDeliveryDetails != null && vwPickingForDeliveryDetails.length > 0">
							<app-list :isDataLoading="isVwPickingForDeliveryDetailLoading"
								:dataCount="vwPickingForDeliveryDetails.length">
								<delivery-instruction-item-detail v-for="(item, index) in vwPickingForDeliveryDetails" :model="item" :key="index"
									@nextAction="goToNextByDeliveryInstructionDetail(3, item)" :isDisabled="checkIsDeliveryInstructionDetailDisabled(item)" />
							</app-list>
						</span>

					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 3">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" label="Part Number" :model="selectedVwPickingForDeliveryDetail.partPartNumber" />
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="selectedVwPickingForDeliveryDetail.partPartName" />
						<b-row>
							<b-col cols="6">
								<app-label label-cols-lg="12" size="sm" label="Plan Qty" :model="selectedVwPickingForDeliveryDetail.pickingForDeliveryDetailPlanQty" />
							</b-col>
							<b-col cols="6">
							<app-label label-cols-lg="12" size="sm" label="Remaining Qty" :model="selectedVwPickingForDeliveryDetail.pickingForDeliveryDetailRemainingQty" />
							</b-col>
						</b-row>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-scan-delivery-card" ref="fieldset-scan-delivery-card" :model.sync="inputQrCodeDeliveryCard" label="Scan Delivery Card" @scannedMethod="scanDeliveryCard" :isBusy="isScanDeliveryCardLoading" :waitInputScan="waitInputScanDeliveryCard" @clearMethod="clearMethodScanDeliveryCard" :isFocus="isFocusScanDeliveryCard"/>
						<app-input-scan id="fieldset-scan-case-source" ref="fieldset-scan-case-source" :model.sync="inputQrCodeCaseSource" label="Scan Source Case" @scannedMethod="scanCaseSource" :isBusy="isScanCaseSourceLoading" :waitInputScan="waitInputScanCaseSource" @clearMethod="clearMethodScanCaseSource" :isFocus="isFocusScanCaseSource"/>
						<app-input-textbox id="fieldset-remark" label-cols-lg="12"  label="Remark" label-for="input-remark" size="sm" :model.sync="remarkInput"/>
					</b-col>
				</b-row>
			</span>

        </div>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-action-button>
			<!-- <b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right"
			@click="goToNext(2)">Next</b-button> -->
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-outline-success float-right"
				@click="printPdfCustom()">Print List</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right"
				@click="saveAction()">Finish</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-outline-success float-right"
				@click="nextAction()">Next</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right"
				@click="checkActualAndPlanQty()">Finish</b-button>
		</template>
        <!-- <template #modal-action-button>
			
			<b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right" @click="saveAction()">Finish</b-button>

        </template> -->
		<!-- <PickingForDeliveryDetailScan
			:parentLabelInfo="parentLabelInfo"
			:parentValueInfo="parentValueInfo"
			:model="modelPickingForDeliveryDetail"
			:modelId="pickingForDeliveryDetailId"
			:openPopup="isShowPopupPickingForDeliveryDetail"
			@resetMethod="resetModal"
			@addButtonMethod="addRowDataPickingForDeliveryDetail"/>
		<PickingCardDetailScan
			:parentLabelInfo="parentLabelInfo"
			:parentValueInfo="parentValueInfo"
			:model="modelPickingCardDetail"
			:modelId="pickingCardDetailId"
			:openPopup="isShowPopupPickingCardDetail"
			@resetMethod="resetModal"
			@addButtonMethod="addRowDataPickingCardDetail"/> -->
			<PopupPDF :openPopup="isShowPopUpPdf" :pdfUrl="pdfUrl" @resetModalMethod="resetModalPopup" label="Print Delivery Instruction" />
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import moment from 'moment';
import { required, minLength } from "vuelidate/lib/validators";
import DeliveryInstructionItem from '@/views/PickingForDelivery/component/DeliveryInstructionItem';
import DeliveryInstructionItemDetail from '@/views/PickingForDelivery/component/DeliveryInstructionItemDetail';
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppInputScanWithDisable from '@/components/AppInputScanWithDisable';
import AppList from '@/components/AppList';
import PickingForDelivery from '@/models/PickingForDelivery/PickingForDelivery';
import VwPickingForDeliveryByDeliveryInstructionFilter from '@/filters/VwPickingForDeliveryByDeliveryInstruction/VwPickingForDeliveryByDeliveryInstructionFilter';
import VwPickingForDeliveryByDeliveryInstruction from '@/models/VwPickingForDeliveryByDeliveryInstruction/VwPickingForDeliveryByDeliveryInstruction';
import VwPickingForDeliveryDetailFilter from '@/filters/VwPickingForDeliveryDetail/VwPickingForDeliveryDetailFilter';
import VwPickingForDeliveryDetail from '@/models/VwPickingForDeliveryDetail/VwPickingForDeliveryDetail';
import PickingForDeliveryList from '@/models/PickingForDelivery/PickingForDeliveryList';
import PickingForDeliveryFilter from '@/filters/PickingForDelivery/PickingForDeliveryFilter';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import PickingStatus from '@/models/PickingStatus/PickingStatus';
import PickingStatusFilter from '@/filters/PickingStatus/PickingStatusFilter';
import PickingForDeliveryDetail from '@/models/PickingForDelivery/PickingForDeliveryDetail';
import PickingForDeliveryDetailFilter from '@/filters/PickingForDelivery/PickingForDeliveryDetailFilter';
import PickingCardDetail from '@/models/PickingForDelivery/PickingCardDetail';
import PickingCardDetailFilter from '@/filters/PickingForDelivery/PickingCardDetailFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PickingForDeliveryDetailInput from '@/views/PickingForDelivery/PickingForDeliveryDetailInput';
import PickingForDeliveryDetailScan from '@/views/PickingForDelivery/PickingForDeliveryDetailScan';
import PickingForDeliveryDetailUpload from '@/views/PickingForDelivery/PickingForDeliveryDetailUpload';
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PickingCardDetailInput from '@/views/PickingForDelivery/PickingCardDetailInput';
import PickingCardDetailScan from '@/views/PickingForDelivery/PickingCardDetailScan';
import PickingCardDetailUpload from '@/views/PickingForDelivery/PickingCardDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupPDF from '@/components/PopupPDF';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		PickingForDeliveryDetailInput,
		PickingForDeliveryDetailScan,
		PickingForDeliveryDetailUpload,
		PickingCardDetailInput,
		PickingCardDetailScan,
		PickingCardDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppInputScanWithDisable,
		AppList,
		DeliveryInstructionItem,
		DeliveryInstructionItemDetail,
		PopupPDF
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
			deliveryInstructionId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				deliveryInstructionId: { required : "Delivery Instruction is Required."},
			},
			datas: Array(),
			selectAll:false,
			waitInputScanDeliveryCard:false,
			waitInputScanCaseSource:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsPickingForDeliveryDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"deliveryInstructionDetail": { "class" : "th-delivery-instruction-detail first-child", "label" : "Delivery Instruction Detail", key: 'deliveryInstructionDetail.part', sortable: false}}, 
				{"planQty": { "class" : "th-plan-qty", "label" : "Plan Qty", key: 'planQty', sortable: false}}, 
				{"actualQty": { "class" : "th-actual-qty last-child", "label" : "Actual Qty", key: 'actualQty', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsPickingCardDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"pickingDetail": { "class" : "th-picking-detail first-child", "label" : "Picking Detail", key: 'pickingDetail.deliveryInstructionDetail', sortable: false}}, 
				{"deliveryCard": { "class" : "th-delivery-card", "label" : "Delivery Card", key: 'deliveryCard.deliveryCardNumber', sortable: false}}, 
				{"controlCard": { "class" : "th-control-card last-child", "label" : "Control Card", key: 'controlCard.controlCardNumber', sortable: false}}, 
				{"scanDate": { "class" : "th-scan-date d-stack-none", "label" : "Scan Date", key: 'scanDate', sortable: false}}, 
				{"scanBy": { "class" : "th-scan-by d-stack-none", "label" : "Scan By", key: 'scanBy.firstName', sortable: false}}, 
				{"deliveryQty": { "class" : "th-delivery-qty d-stack-none", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			isVwDeliveryInstructionLoading:false,
			isVwPickingForDeliveryDetailLoading:false,
			isVwPickingForDeliveryDetailItemLoading:false,
			selectedVwPickingForDeliveryDetail:null,
			vwDeliveryInstructions :[],
			vwPickingForDeliveryDetails :[],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			selectedDeliveryCard:null,
			selectedCaseSource:null,
			remarkInput:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			modelIdOld: null,
			model: {},
			modelPickingForDeliveryDetail : {},
			isShowPopupPickingForDeliveryDetail : false,
			isShowPopupUploadPickingForDeliveryDetail : false,
			isScanDeliveryCardLoading : false,
			isScanCaseSourceLoading : false,
			modelPickingCardDetail : {},
			isShowPopupPickingCardDetail : false,
			isShowPopupUploadPickingCardDetail : false,
			isShowPopupPickingCardDetailScan : false,
			filterPickingForDelivery : null,
			currentPickingForDeliveryPage : 1,
			pickingForDeliveryPageSize: 10,
			sortByPickingForDelivery: '',
			sortDescPickingForDelivery: '',
			filterPickingForDeliveryDetail : null,
			currentPickingForDeliveryDetailPage : 1,
			pickingForDeliveryDetailPageSize: 10,
			sortByPickingForDeliveryDetail: '',
			sortDescPickingForDeliveryDetail: '',
			sortingByPickingForDeliveryDetail: [],
			pickingForDeliveryDetails : [],
			pickingForDeliveryDetailId : '',
			totalPickingForDeliveryDetailRow : 0,
			isShowPickingForDeliveryDetailFilter: false,
			isDownloadPickingForDeliveryDetail: false,
			filterPickingCardDetail : null,
			currentPickingCardDetailPage : 1,
			pickingCardDetailPageSize: 10,
			sortByPickingCardDetail: '',
			sortDescPickingCardDetail: '',
			sortingByPickingCardDetail: [],
			pickingCardDetails : [],
			pickingCardDetailId : '',
			totalPickingCardDetailRow : 0,
			isShowPickingCardDetailFilter: false,
			isDownloadPickingCardDetail: false,
			deliveryInstructionDetails: [],
			pickingForDeliveryDetails: [],
			deliveryInstructionDeliveryCards: [],
			controlCards: [],
			userInfos: [],
			deliveryInstructions: [],
			deliveryInstructions: [],
			isDeliveryInstructionComboLoading: false,
			pickingStatuss: [],
			pickingStatuss: [],
			isPickingStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isDeliveryInstructionComboLoading: false,
			isUserInfoComboLoading: false,
			isPickingStatusComboLoading: false,
			isPickingForDeliveryComboLoading: false,
			isDeliveryInstructionDetailComboLoading: false,
			isPickingForDeliveryDetailComboLoading: false,
			isDeliveryInstructionDeliveryCardComboLoading: false,
			isControlCardComboLoading: false,
			scanPageIndex: 0,
			parentLabelInfo: '',
			parentValueInfo: '',
			inputQrCode: '',
			inputQrCodeDetail: '',
			inputQrCodeDeliveryCard: '',
			inputQrCodeCaseSource: '',
			isScanDeliveryInstructionLoading: false,
			isScanDeliveryInstructionItemLoading: false,
			isShowPopUpPdf: false,
			pdfUrl: false,
			isFocusScanDeliveryInstruction :false,
			isFocusScanDeliveryInstructionItem :false,
			isFocusScanDeliveryCard :false,
			isFocusScanCaseSource :false,
		}
	},
	methods : {
		
		async printPdfCustom(){
			let id = this.model.deliveryInstructionId;
			let result = await DeliveryInstruction.printPdfCustom(this, id);
			this.pdfUrl = result.download;
			this.isShowPopUpPdf = true;

		},
		resetModalPopup() {
			this.isShowPopUpPdf = false;
		},
		printList(){

			this_.toast({message: 'Success !', title:'Info', variant : 'nanti print disini',autoHideDelay:750});
		},
		checkIsVwDeliveryInstructionDisabled(iten){
			return false;
		},
		checkIsDeliveryInstructionDetailDisabled(iten){
			return false;
		},

		getVwPickingForDeliveryDetail : async function(input){
			// console.log('getVwPickingForDeliveryDetail',input)
			this.vwPickingForDeliveryDetails = [];
			if (this.modelId == null || this.modelId==undefined) {
				return;
			}
			var vwPickingDetailFilter = new VwPickingForDeliveryDetailFilter();

			if (input != undefined) {
				vwPickingDetailFilter.partPartNumber = input;
			}
			this.isVwPickingForDeliveryDetailLoading = true;
			vwPickingDetailFilter.pickingForDeliveryId = this.modelId;
			vwPickingDetailFilter.showIsUncompleteOnly = true;
			
			vwPickingDetailFilter.deliveryInstructionDetailStatusCode = [];
			//vwPickingDetailFilter.deliveryInstructionDetailStatusCode.push("READY_FOR_PICKING");
			this.vwPickingForDeliveryDetails = [];
			
			let sortingByPickingCardDetail = [];

			VwPickingForDeliveryDetail.getListVw(this,vwPickingDetailFilter,sortingByPickingCardDetail,0, 10)
			.then((result)=>{
				this.vwPickingForDeliveryDetails = result.data
				this.isVwPickingForDeliveryDetailLoading = false;
			})
			.catch(error => { this.isVwPickingForDeliveryDetailLoading = false; });
		},
		getVwPickingForDeliveryDetailByPickingDetailId : async function(id){
			if (id==null || id==undefined || id=='') {
				return;
			}
			// console.log('getVwPickingForDeliveryDetailById',input);

			await VwPickingForDeliveryDetail.getByIdDetailId(this,id)
			.then((result)=>{
				// console.log(result);
				this.selectedVwPickingForDeliveryDetail = result;
				this.isVwPickingForDeliveryDetailItemLoading = false;
			})
			.catch(error => { this.isVwPickingForDeliveryDetailItemLoading = false; });
		},
		getVwPickingForDeliveryDetailById : async function(id){
			if (id==null || id==undefined || id=='') {
				return;
			}
			// console.log('getVwPickingForDeliveryDetailById',input);

			await VwPickingForDeliveryDetail.getById(this,id)
			.then((result)=>{
				// console.log(result);
				this.selectedVwPickingForDeliveryDetail = result;
				this.isVwPickingForDeliveryDetailItemLoading = false;
			})
			.catch(error => { this.isVwPickingForDeliveryDetailItemLoading = false; });
		},
		

		getVwDeliveryInstructions : async function(input){
			var vwPickingFilter = new VwPickingForDeliveryByDeliveryInstructionFilter();
			vwPickingFilter.pickingStatusCodeEquals = [];
			vwPickingFilter.pickingStatusCodeEquals.push("OPEN");
			vwPickingFilter.pickingStatusCodeEquals.push("IN_PROGRESS");
			if (input != undefined) {
				vwPickingFilter.deliveryInstructionNumber = input;
			}
			this.isVwDeliveryInstructionLoading = true;
			let sortingByVwPickingForDeliveryInstruction = [];
			sortingByVwPickingForDeliveryInstruction["deliveryinstructiondideliverydate"] = 1;
			// PickingCardDetail.getList(this, filter, this.sortingByVwPickingForDeliveryInstruction, currentPage , this.pickingCardDetailPageSize).then(result => {

			VwPickingForDeliveryByDeliveryInstruction.getListVw(this,vwPickingFilter,sortingByVwPickingForDeliveryInstruction,0,10)
			.then((result)=>{
				this.vwDeliveryInstructions = result.data
				this.isVwDeliveryInstructionLoading = false;
			})
			.catch(error => { this.isVwDeliveryInstructionLoading = false; });
		},
		getPickingForDelivery : async function(id) {
			this.isBusy = true;
			PickingForDelivery.getData(this, id).then(result => {
				this.setModel(result)
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
				if (result.deliveryInstructionId==null) {
					this.goToNext(1);
					return;
				}
				if (this.model) {
					this.goToNext(2,this.model);
				}
			}).catch(error => { this.isBusy = false; });
		},
		// downloadData() {
		// 	this.isDownloadPickingForDelivery = true;
		// 	this.filterPickingForDelivery.id = this.modelId;
		// 	PickingForDelivery.downloadDataDetail(this, this.filterPickingForDelivery).then(result => {
		// 		this.isDownloadPickingForDelivery = false;
		// 	}).catch(error => { this.isDownloadPickingForDelivery = false; })
		// },
		// getPickingForDeliveryDetails : async function(isAddRow) {
		// 	let filter = {};
		// 	Object.assign(filter, this.filterPickingForDeliveryDetail);
		// 	if (this.modelId == null) return;
		// 	filter.pickingForDeliveryId = this.modelId;
		// 	filter.draftMode = "1";
		// 	if (this.sortByPickingForDeliveryDetail != null) {
		// 		this.sortingByPickingForDeliveryDetail[this.sortByPickingForDeliveryDetail] = this.sortDescPickingForDeliveryDetail;
		// 	}
		// 	let currentPage = (this.currentPickingForDeliveryDetailPage - 1);
		// 	if (isAddRow) {
		// 		let totalData = this.totalPickingForDeliveryDetailRow + 1;
		// 		let page = Math.ceil(totalData/this.pickingForDeliveryDetailPageSize);
		// 		currentPage = page - 1;
		// 	}
		// 	// disable paging start
		// 	currentPage = null;
		// 	this.pickingForDeliveryDetailPageSize = 0;
		// 	// disable paging end
		// 	PickingForDeliveryDetail.getList(this, filter, this.sortingByPickingForDeliveryDetail, currentPage , this.pickingForDeliveryDetailPageSize).then(result => {
		// 		this.currentPickingForDeliveryDetailPage = currentPage + 1;
		// 		this.pickingForDeliveryDetails = result.data.filter(obj =>
		// 			Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
		// 			);
		// 		this.pickingForDeliveryDetailsFiltered = result.data.filter(obj =>
		// 			Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
		// 			);
		// 		this.totalPickingForDeliveryDetailRow = result.dataCount;
		// 	}).catch(error => {});
		// },
		// getPickingCardDetails : async function(isAddRow) {
		// 	let filter = {};
		// 	Object.assign(filter, this.filterPickingCardDetail);
		// 	if (this.modelId == null) return;
		// 	filter.pickingForDeliveryId = this.modelId;
		// 	filter.draftMode = "1";
		// 	if (this.sortByPickingCardDetail != null) {
		// 		this.sortingByPickingCardDetail[this.sortByPickingCardDetail] = this.sortDescPickingCardDetail;
		// 	}
		// 	let currentPage = (this.currentPickingCardDetailPage - 1);
		// 	if (isAddRow) {
		// 		let totalData = this.totalPickingCardDetailRow + 1;
		// 		let page = Math.ceil(totalData/this.pickingCardDetailPageSize);
		// 		currentPage = page - 1;
		// 	}
		// 	// disable paging start
		// 	currentPage = null;
		// 	this.pickingCardDetailPageSize = 0;
		// 	// disable paging end
		// 	PickingCardDetail.getList(this, filter, this.sortingByPickingCardDetail, currentPage , this.pickingCardDetailPageSize).then(result => {
		// 		this.currentPickingCardDetailPage = currentPage + 1;
		// 		this.pickingCardDetails = result.data.filter(obj =>
		// 			Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
		// 			);
		// 		this.pickingCardDetailsFiltered = result.data.filter(obj =>
		// 			Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
		// 			);
		// 		this.totalPickingCardDetailRow = result.dataCount;
		// 	}).catch(error => {});
		// },
		getPickingForDeliverys : async function(input) {
			let filter = new PickingForDeliveryFilter();
			if (input != undefined) {
				filter.PickingNumber = input;
			}
			this.isPickingForDeliveryComboLoading = true;
			await PickingForDelivery.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingForDeliverys = result.data
				}
				this.isPickingForDeliveryComboLoading = false;
			})
			.catch(error => {});
		},
		// getPickingForDeliverys : async function(input) {
		// 	let filter = new PickingForDeliveryFilter();
		// 	if (input != undefined) {
		// 		filter.pickingNumber = input;
		// 	}
		// 	this.isPickingForDeliveryComboLoading = true;
		// 	await PickingForDelivery.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.pickingForDeliverys = result.data
		// 		}
		// 		this.isPickingForDeliveryComboLoading = false;
		// 	})
		// 	.catch(error => {});
		// },
		// getDeliveryInstructionDetails : async function(input) {
		// 	let filter = new DeliveryInstructionDetailFilter();
		// 	if (input != undefined) {
		// 		filter.part = input;
		// 	}
		// 	this.isDeliveryInstructionDetailComboLoading = true;
		// 	await DeliveryInstructionDetail.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.deliveryInstructionDetails = result.data
		// 		}
		// 		this.isDeliveryInstructionDetailComboLoading = false;
		// 	})
		// 	.catch(error => {});
		// },
		// getPickingForDeliveryDetails : async function(input) {
		// 	let filter = new PickingForDeliveryDetailFilter();
		// 	if (input != undefined) {
		// 		filter.deliveryInstructionDetail = input;
		// 	}
		// 	this.isPickingForDeliveryDetailComboLoading = true;
		// 	await PickingForDeliveryDetail.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.pickingForDeliveryDetails = result.data
		// 		}
		// 		this.isPickingForDeliveryDetailComboLoading = false;
		// 	})
		// 	.catch(error => {});
		// },
		// getDeliveryInstructionDeliveryCards : async function(input) {
		// 	let filter = new DeliveryInstructionDeliveryCardFilter();
		// 	if (input != undefined) {
		// 		filter.deliveryCardNumber = input;
		// 	}
		// 	this.isDeliveryInstructionDeliveryCardComboLoading = true;
		// 	await DeliveryInstructionDeliveryCard.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.deliveryInstructionDeliveryCards = result.data
		// 		}
		// 		this.isDeliveryInstructionDeliveryCardComboLoading = false;
		// 	})
		// 	.catch(error => {});
		// },
		// getControlCards : async function(input) {
		// 	let filter = new ControlCardFilter();
		// 	if (input != undefined) {
		// 		filter.controlCardNumber = input;
		// 	}
		// 	this.isControlCardComboLoading = true;
		// 	await ControlCard.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.controlCards = result.data
		// 		}
		// 		this.isControlCardComboLoading = false;
		// 	})
		// 	.catch(error => {});
		// },
		// getUserInfos : async function(input) {
		// 	let filter = new UserInfoFilter();
		// 	if (input != undefined) {
		// 		filter.firstName = input;
		// 	}
		// 	this.isUserInfoComboLoading = true;
		// 	await UserInfo.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.userInfos = result.data
		// 		}
		// 		this.isUserInfoComboLoading = false;
		// 	})
		// 	.catch(error => {});
		// },
		// getDeliveryInstructions : async function(input) {
		// 	let filter = new DeliveryInstructionFilter();
		// 	if (input != undefined) {
		// 		filter.diNumber = input;
		// 	}
		// 	await DeliveryInstruction.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.deliveryInstructions = result.data
		// 		}
		// 	})
		// 	.catch(error => {});
		// },
		// setSelectedDeliveryInstruction(item) {
		// 	if(item == undefined || item == null) {
		// 		this.model.deliveryInstructionId = null;
		// 		this.model.deliveryInstruction = null;
		// 	} else {
		// 		this.model.deliveryInstructionId = item.id;
		// 		this.model.deliveryInstruction = item;
		// 	}
		// 	this.$forceUpdate();
		// 	this.updateData();
		// },
		// setSelectedPickingBy(item) {
		// 	if(item == undefined || item == null) {
		// 		this.model.pickingByUserName = null;
		// 		this.model.pickingBy = null;
		// 	} else {
		// 		this.model.pickingByUserName = item.userName;
		// 		this.model.pickingBy = item;
		// 	}
		// 	this.$forceUpdate();
		// 	this.updateData();
		// },
		// getPickingStatuss : async function(input) {
		// 	let filter = new PickingStatusFilter();
		// 	if (input != undefined) {
		// 		filter.name = input;
		// 	}
		// 	await PickingStatus.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.pickingStatuss = result.data
		// 		}
		// 	})
		// 	.catch(error => {});
		// },
		// setSelectedPickingStatus(item) {
		// 	if(item == undefined || item == null) {
		// 		this.model.pickingStatusId = null;
		// 		this.model.pickingStatus = null;
		// 	} else {
		// 		this.model.pickingStatusId = item.id;
		// 		this.model.pickingStatus = item;
		// 	}
		// 	this.$forceUpdate();
		// 	this.updateData();
		// },
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.pickingForDeliveryInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}

			try {
				this.isBusy = true;
				if (this.modelId==null || this.modelId==undefined||this.modelId=="") {
					this_.toast({message: 'Invalid Model Id', title:'Error', variant : 'danger'});
					return;
				}
				let this_ = this;
				// console.log(this.modelId);

				this.$http.post('PickingForDelivery/FinishScanDelivery/'+this.modelId)
				.then(async function(response){
					// console.log(response);
					if(response != null) {
						this_.resetSavedValue(true);
						this_.toast({message: 'Success Finish Scan Delivery', title:'Success', variant : 'success',autoHideDelay:750});
						// this_.goToNext(1);

						// this_.$router.push({ name: 'pickingfordeliveryindex' });
						await this_.getVwDeliveryInstructions();
						this_.$router.back();
							// await PickingForDelivery.createData(this_).then(result => {
							// 	if (result != null) {
							// 		if (result.id != null && result.id != "") {
							// 			// let createRoute = 'pickingfordeliveryscan';
							// 			// console.log('result to redirect',result)
							// 			this.$router.back();
							// 			// this_.$router.push({ name: createRoute, params : { id: result.id } });
							// 			this_.getPickingForDelivery(result.id);
							// 			// this_.goToNext(1);
							// 		}
							// 	}
							// 	// this.isCreateBusy = false;
							// }).catch(error => {
							// 	// this.isCreateBusy = false;
							// })
					
						// this_.$router.push({ name: 'pickingfordeliveryscan',params : { id: null }});

						return;
					}
					this_.toast({message: 'gagal Finish Scan Delivery', title:'Error', variant : 'danger'});
				})
				.catch((error) => {
					// console.log(error)
					var stringError = 'gagal Finish Scan Delivery !';
					if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
						let errorList = Object.values(error.response.data.errors);
						const errorObj = errorList.find(() => true);
						stringError =errorObj[0];
					}
					this_.toast({message: stringError, title:'Error', variant : 'danger'});
				});

				// let id = this.$route.params.id;
				// this.$v.model.$touch(); 
				// if (this.$v.model.$anyError) {
				// 	return;
				// } else {
				// 	this.isBusy = true;
				// 	let id = this.modelId;
				// 	let model = this.model;

				// 	if (id != '' && id != null && id != undefined) {
				// 		PickingForDelivery.commitData(this, model, id).then(result => {
				// 			this.isDataCommited = true;
				// 			this.$router.push({ name: 'pickingfordeliveryindex' });
				// 			this.isBusy = false;
				// 		}).catch(error => { this.isBusy = false; });
				// 	} else {
				// 		PickingForDelivery.insertData(this, model).then(result => {
				// 			this.isDataCommited = true;
				// 			this.$router.push({ name: 'pickingfordeliveryindex' });
				// 			this.isBusy = false;
				// 		}).catch(error => { this.isBusy = false; });
				// 	}
				// }
			} catch (error) { this.isBusy = false; }
			finally {
				this.isBusy = false;
			}

		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return PickingForDelivery.updateData(this, model, id)
					.catch((error) => {
						return this.getPickingForDelivery(id);
					});
				}
				return false;
			});
		},
		onHidden() {
			this.getPickingForDeliverys();
		},
		// addRowDataPickingForDeliveryDetail(modalEvent, model) {
		// 	if (model != null) {
		// 		model.isScanned = true;
		// 		if (model.id != null && model.id != '') {
		// 			model.pickingForDeliveryId =  this.modelId;
		// 			PickingForDeliveryDetail.updateDataDetail(this, model, model.id)
		// 			.then(result => {
		// 				this.getPickingForDeliveryDetails(true);
		// 				this.isShowPopupPickingForDeliveryDetail = false;
		// 			})
		// 		} else {
		// 			model.pickingForDeliveryId =  this.modelId;
		// 			PickingForDeliveryDetail.createDataDetail(this, model)
		// 			.then(result => {
		// 				this.getPickingForDeliveryDetails(true);
		// 				this.isShowPopupPickingForDeliveryDetail = false;
		// 			})
		// 		}
		// 	}
		// },
		// async editRowDataPickingForDeliveryDetail(id) {
		// 	this.pickingForDeliveryDetailId = id;
		// 	this.isShowPopupPickingForDeliveryDetail = true; 
		// },
		// async deleteRowDataPickingForDeliveryDetail(id) {
		// 	PickingForDeliveryDetail.deleteData(this, id).then(result => { this.getPickingForDeliveryDetails(); });
		// },
		// async resetDataPickingForDeliveryDetail() {
		// 	this.pickingForDeliveryDetailId = "";
		// 	this.isShowPopupPickingForDeliveryDetail = true;
		// },
		// async addDataPickingForDeliveryDetail() {
		// 	PickingForDeliveryDetail.createData(this, { pickingForDeliveryId: this.modelId })
		// 	.then(result => {
		// 		this.getPickingForDeliveryDetails(true);
		// 	})
		// },
		// async addFromClipboardPickingForDeliveryDetail() {
		// 	let deliveryInstructionDetails = new Array();
		// 	navigator.clipboard.readText().then(value => {
		// 		if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
		// 		let values = value.split(",");
		// 		values.forEach(item => {
		// 			deliveryInstructionDetails.push({ deliveryInstructionDetail: item, pickingForDeliveryId: this.modelId });
		// 		});
		// 		PickingForDeliveryDetail.addFromClipboard(this, deliveryInstructionDetails).then(result => { this.getPickingForDeliveryDetails() });
		// 	});
		// },
		// async replaceFromClipboardPickingForDeliveryDetail() {
		// 	let deliveryInstructionDetails = new Array();
		// 	navigator.clipboard.readText().then(value => {
		// 		if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
		// 		let values = value.split(",");
		// 		values.forEach(item => {
		// 			deliveryInstructionDetails.push({ deliveryInstructionDetail: item, pickingForDeliveryId: this.modelId });
		// 		});
		// 		PickingForDeliveryDetail.replaceFromClipboard(this, deliveryInstructionDetails).then(result => { this.getPickingForDeliveryDetails() });
		// 	});   
		// },
		// showPopupUploadPickingForDeliveryDetail() {
		// 	this.isShowPopupUploadPickingForDeliveryDetail = true;
		// },
		// uploadDataPickingForDeliveryDetail(modalEvent, newDatas) {
		// 	this.isShowPopupUploadPickingForDeliveryDetail = false; 
		// },
		// downloadPickingForDeliveryDetail(modalEvent) {
		// 	this.isDownloadPickingForDeliveryDetail = true;
		// 	this.filterPickingForDeliveryDetail.pickingForDeliveryId = this.modelId;
		// 	PickingForDeliveryDetail.downloadDataDetail(this, this.filterPickingForDeliveryDetail).then(result => {
		// 		this.isDownloadPickingForDeliveryDetail = false;
		// 	}).catch(error => { this.isDownloadPickingForDeliveryDetail = false; })
		// },
		// saveInputPickingForDeliveryDetail(item) {
		// 	if (this.pickingForDeliverys != null && this.pickingForDeliverys != undefined  && this.pickingForDeliverys.length > 0) {
		// 		item.pickingForDelivery = this.pickingForDeliverys.find(q => q.id == item.pickingForDeliveryId);
		// 	}
		// 	if (this.deliveryInstructionDetails != null && this.deliveryInstructionDetails != undefined  && this.deliveryInstructionDetails.length > 0) {
		// 		item.deliveryInstructionDetail = this.deliveryInstructionDetails.find(q => q.id == item.deliveryInstructionDetailId);
		// 	}

		// 	let id = item.id;
		// 	let promises = Array();

		// 	Promise.all(promises).then((results) => {
		// 		if (id != '' && id != null && id != undefined) {
		// 			PickingForDeliveryDetail.updateData(this, item, item.id);
		// 		}
		// 	});
		// },
		// addRowDataPickingCardDetail(modalEvent, model) {
		// 	if (model != null) {
		// 		model.isScanned = true;
		// 		if (model.id != null && model.id != '') {
		// 			model.pickingForDeliveryId =  this.modelId;
		// 			PickingCardDetail.updateDataDetail(this, model, model.id)
		// 			.then(result => {
		// 				this.getPickingCardDetails(true);
		// 				this.isShowPopupPickingCardDetail = false;
		// 			})
		// 		} else {
		// 			model.pickingForDeliveryId =  this.modelId;
		// 			PickingCardDetail.createDataDetail(this, model)
		// 			.then(result => {
		// 				this.getPickingCardDetails(true);
		// 				this.isShowPopupPickingCardDetail = false;
		// 			})
		// 		}
		// 	}
		// },
		// async editRowDataPickingCardDetail(id) {
		// 	this.pickingCardDetailId = id;
		// 	this.isShowPopupPickingCardDetail = true; 
		// },
		// async deleteRowDataPickingCardDetail(id) {
		// 	PickingCardDetail.deleteData(this, id).then(result => { this.getPickingCardDetails(); });
		// },
		// async resetDataPickingCardDetail() {
		// 	this.pickingCardDetailId = "";
		// 	this.isShowPopupPickingCardDetail = true;
		// },
		// async addDataPickingCardDetail() {
		// 	PickingCardDetail.createData(this, { pickingForDeliveryId: this.modelId })
		// 	.then(result => {
		// 		this.getPickingCardDetails(true);
		// 	})
		// },
		// async addFromClipboardPickingCardDetail() {
		// 	let deliveryCards = new Array();
		// 	navigator.clipboard.readText().then(value => {
		// 		if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
		// 		let values = value.split(",");
		// 		values.forEach(item => {
		// 			deliveryCards.push({ deliveryCard: item, pickingForDeliveryId: this.modelId });
		// 		});
		// 		PickingCardDetail.addFromClipboard(this, deliveryCards).then(result => { this.getPickingCardDetails() });
		// 	});
		// },
		// async replaceFromClipboardPickingCardDetail() {
		// 	let deliveryCards = new Array();
		// 	navigator.clipboard.readText().then(value => {
		// 		if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
		// 		let values = value.split(",");
		// 		values.forEach(item => {
		// 			deliveryCards.push({ deliveryCard: item, pickingForDeliveryId: this.modelId });
		// 		});
		// 		PickingCardDetail.replaceFromClipboard(this, deliveryCards).then(result => { this.getPickingCardDetails() });
		// 	});   
		// },
		// showPopupUploadPickingCardDetail() {
		// 	this.isShowPopupUploadPickingCardDetail = true;
		// },
		// uploadDataPickingCardDetail(modalEvent, newDatas) {
		// 	this.isShowPopupUploadPickingCardDetail = false; 
		// },
		// downloadPickingCardDetail(modalEvent) {
		// 	this.isDownloadPickingCardDetail = true;
		// 	this.filterPickingCardDetail.pickingForDeliveryId = this.modelId;
		// 	PickingCardDetail.downloadDataDetail(this, this.filterPickingCardDetail).then(result => {
		// 		this.isDownloadPickingCardDetail = false;
		// 	}).catch(error => { this.isDownloadPickingCardDetail = false; })
		// },
		// saveInputPickingCardDetail(item) {
		// 	if (this.pickingForDeliveryDetails != null && this.pickingForDeliveryDetails != undefined  && this.pickingForDeliveryDetails.length > 0) {
		// 		item.pickingDetail = this.pickingForDeliveryDetails.find(q => q.id == item.pickingDetailId);
		// 	}
		// 	if (this.deliveryInstructionDeliveryCards != null && this.deliveryInstructionDeliveryCards != undefined  && this.deliveryInstructionDeliveryCards.length > 0) {
		// 		item.deliveryCard = this.deliveryInstructionDeliveryCards.find(q => q.id == item.deliveryCardId);
		// 	}
		// 	if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
		// 		item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
		// 	}
		// 	if (this.userInfos != null && this.userInfos != undefined  && this.userInfos.length > 0) {
		// 		item.scanBy = this.userInfos.find(q => q.id == item.scanByUserName);
		// 	}

		// 	let id = item.id;
		// 	let promises = Array();

		// 	Promise.all(promises).then((results) => {
		// 		if (id != '' && id != null && id != undefined) {
		// 			PickingCardDetail.updateData(this, item, item.id);
		// 		}
		// 	});
		// },
		resetModal(modalType) {
			this.isShowPopupUploadPickingForDeliveryDetail = false; 
			this.isShowPopupPickingForDeliveryDetail = false; 
			if (modalType == 'PickingForDeliveryDetail') {
				this.getPickingForDeliveryDetails();
			}
			this.isShowPopupUploadPickingCardDetail = false; 
			this.isShowPopupPickingCardDetail = false; 
			if (modalType == 'PickingCardDetail') {
				this.getPickingCardDetails();
			}
			this.inputQrCode = '';
			this.inputQrCodeDetail = '';
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		async goToNextByDeliveryInstruction(page,item){
			this.inputQrCode = item.deliveryInstructionNumber;
			this.scanDeliveryInstruction();
		},
		goToNextByDeliveryInstructionDetail(page,item){
			this.inputQrCodeDetail = item.partPartNumber;
			this.scanDeliveryInstructionItem();

		},
		setVwPickingDetail(item){
			this.selectedVwPickingForDeliveryDetail = item;
			this.selectedPickingForDeliveryDetailId = item.pickingForDeliveryDetailId;

			if (item.pickingForDeliveryDetailId==null || item.pickingForDeliveryDetailId==undefined) {
				this.selectedPickingForDeliveryDetailId = '';
			}
			this.remarkInput = item.pickingForDeliveryDetailRemark==null || item.pickingForDeliveryDetailRemark==undefined?'':item.pickingForDeliveryDetailRemark;
		},
		resetSavedValue(isVResetwPickingDetail=false){
			this.selectedDeliveryCard = null;
			this.selectedCaseSource = null;
			if (isVResetwPickingDetail) {
				this.selectedVwPickingForDeliveryDetail = null;
				this.selectedPickingForDeliveryDetailId = '';
			}

		},
		async checkActualAndPlanQty() {
			console.log("check qty", this.selectedVwPickingForDeliveryDetail);
			let selectedObj = this.selectedVwPickingForDeliveryDetail;
			if(selectedObj.pickingForDeliveryDetailPlanQty != selectedObj.pickingForDeliveryDetailActualQty) {
				let message = 'Apakah anda yakin untuk melakukan Delivery secara Parsial?';
				if(!await this.showPopupWithMessage(message)) return;

				await this.saveActionItem();
				return;
			} else {
				await this.saveActionItem();
				return;
			}

		},
		async saveActionItem(){
			let this_ = this;
			this_.isBusy = true;
			let selectedVwPickingForDeliveryDetailId = this.selectedVwPickingForDeliveryDetail!=null?this.selectedVwPickingForDeliveryDetail.id:'';
			this_.waitInputScanDeliveryCard = false;
			this_.waitInputScanCaseSource = false;
			this_.inputQrCodeCaseSource = '';
			this_.inputQrCodeDeliveryCard = '';
			let data = { 
				"pickingForDeliveryDetailId": this.selectedPickingForDeliveryDetailId,
				"remark": this.remarkInput
			 };
			await this.$http.post('PickingForDelivery/FinishScanDeliveryItem',data)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					this_.resetSavedValue();
					this_.toast({message: 'Success Finish Scan Delivery Item !', title:'Success', variant : 'success',autoHideDelay:750});
					this_.goToNext(2);
					this_.waitInputScanDeliveryCard = false;
					this_.waitInputScanCaseSource = false;
					this_.isBusy = false;
					return;
				}
				this_.toast({message: 'gagal menyimpan melakukan scan Delivery Instruction Item', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				this_.isBusy = false;
				// console.log(error)
				var stringError = 'gagal menyimpan !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
			});
			this_.isBusy = false;
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		async nextAction(){
			let this_ = this;
			this.isBusy = true;
			
			let selectedVwPickingForDeliveryDetailId = this.selectedVwPickingForDeliveryDetail!=null && this.selectedVwPickingForDeliveryDetail!=undefined ?this.selectedVwPickingForDeliveryDetail.id :'' ;
			let selectedDeliveryCardId = this.selectedDeliveryCard!=null && this.selectedDeliveryCard!=undefined ? this.selectedDeliveryCard.deliveryInstructionDeliveryCardId : 0;
			let selectedCaseSourceId = this.selectedCaseSource != null && this.selectedCaseSource!=undefined ?this.selectedCaseSource.id:0;
			
			// console.log('selectedVwPickingForDeliveryDetailId',selectedVwPickingForDeliveryDetailId)
			// console.log('selectedVwPickingForDeliveryDetailId  ',this.selectedDeliveryCard)
			// console.log('selectedDeliveryCardId',selectedDeliveryCardId)
			// console.log('selectedCaseSourceId',selectedCaseSourceId)
			let data = { 
				"pickingForDeliveryDetailId": this.selectedPickingForDeliveryDetailId,
				"selectedDeliveryCardId": selectedDeliveryCardId,
				"selectedCaseSourceId": selectedCaseSourceId,
				"remark": this.remarkInput,
			};
			await this.$http.post('PickingForDelivery/NextScanDeliveryItem',data)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					this_.resetSavedValue();
					
					this_.waitInputScanDeliveryCard = false;
					this_.waitInputScanCaseSource = false;
					this_.getVwPickingForDeliveryDetailByPickingDetailId(this_.selectedPickingForDeliveryDetailId);

					this_.toast({message: 'Success melakukan scan delivery item', title:'Info', variant : 'success',autoHideDelay:750});
					this_.focusScanDeliveryCard();
					this_.isBusy = false;
					return;
				}
				this_.toast({message: 'gagal menyimpan melakukan scan Delivery Instruction Item', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				this_.isBusy = false;
				console.log(error)
				var stringError = 'gagal menyimpan !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				
				this_.getVwPickingForDeliveryDetailByPickingDetailId(this_.selectedPickingForDeliveryDetailId);
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
			});
			
			this.isBusy = false;
		},
		clearMethodScanDeliveryCard(){
			this.focusScanDeliveryCard();
			this.selectedDeliveryCard = null;
			this.waitInputScanDeliveryCard = false;
		},
		async scanDeliveryCard(){
			let qrCode = encodeURIComponent(this.inputQrCodeDeliveryCard);
			this.isScanDeliveryCardLoading = true;
			this.selectedDeliveryCard = null;
			let this_ = this;

			
			let data = { 
				"vwPickingForDetailId": this.selectedPickingForDeliveryDetailId,
				"deliveryCardNumber": qrCode,
			};

			await this.$http.post('PickingForDelivery/ScanDeliveryDeliveryCard',data)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					this_.selectedDeliveryCard = response.data;
					
					this_.isScanDeliveryCardLoading = false;
					this_.isFocusScanDeliveryCard = false;
					this_.waitInputScanDeliveryCard = true;

					// console.log("this_.setModel(response.data);",response.data);
					this_.setVwPickingDetail(response.data);
					this_.toast({message: 'Sukses melakukan scan delivery card !', title:'Info', variant : 'success',autoHideDelay:750});
					this_.focusScanCaseSource();
					return;
				}
				this_.isScanDeliveryCardLoading = false;
				this_.toast({message: 'Delivery Instruction Item tidak ditemukan !(1)', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				// console.log(error)
				var stringError = 'tidak ditemukan Delivery Item !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.isScanDeliveryCardLoading = false;
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
			});
			this.inputQrCodeDeliveryCard = '';
		},
		clearMethodScanCaseSource(){
			this.focusScanCaseSource();
			this.selectedCaseSource = null;
			this.waitInputScanCaseSource = false;
		},
		async scanCaseSource(){
			let qrCode = encodeURIComponent(this.inputQrCodeCaseSource);
			this.isScanCaseSourceLoading = true;
			let this_ = this;
			

			let data = { 
				"vwPickingForDetailId": this.selectedPickingForDeliveryDetailId,
				"caseSourceNumber": qrCode,
			};
			await this.$http.post('PickingForDelivery/ScanDeliveryCaseSource',data)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					this_.selectedCaseSource = response.data;
					this_.toast({message: 'Sukses melakukan scan Case Source !', title:'Info', variant : 'success',autoHideDelay:750});
					
					this_.isFocusScanCaseSource = false;
					this_.isScanCaseSourceLoading = false;
					this_.waitInputScanCaseSource = true;
					return;
				}
				this_.isScanCaseSourceLoading = false;

				this_.toast({message: 'Delivery Instruction Item tidak ditemukan !(1)', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				// console.log(error)
				var stringError = 'Tidak ditemukan CaseSource Item !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.isScanCaseSourceLoading = false;
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
			});
			
			this.inputQrCodeCaseSource = '';
		},
		// async scanDeliveryInstructionItem(toPageParam){
		// 	let qrCode = encodeURIComponent(this.inputQrCodeDetail);
		// 	let id = this.model.id;
		// 	let this_ = this;
		// 	let toPage = 3;
		// 	if (toPageParam!=null && toPageParam!=undefined) {
		// 		toPage = toPageParam;
		// 	}
		// 	await this.$http.get('PickingForDelivery/ScanDeliveryInstructionItem?pickingForDeliveryId='+this.modelId+'&qrcode=' + qrCode)
		// 	.then(async function(response){
		// 		console.log(response);
		// 		if(response != null) {
		// 			console.log('ScanDeliveryInstructionItem',response.data);
		// 			this_.setVwPickingDetail(response.data);
		// 			let result = response.data;
		// 			return;
		// 		}
		// 		this_.toast({message: 'Delivery Instruction Item tidak ditemukan !(1)', title:'Error', variant : 'danger'});
		// 	})
		// 	.catch((error) => {
		// 		console.log(error)
		// 		var stringError = 'tidak ditemukan Delivery Instruction Item !';
		// 		if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
		// 			let errorList = Object.values(error.response.data.errors);
		// 			const errorObj = errorList.find(() => true);
		// 			stringError =errorObj[0];
		// 		}
		// 		this_.toast({message: stringError, title:'Error', variant : 'danger'});
		// 	});
		// },
		async scanDeliveryInstructionItem(toPageParam){
			this.isBusy = true;
			let qrCode = encodeURIComponent(this.inputQrCodeDetail);
			this.isScanDeliveryInstructionItemLoading = true;
			let id = this.model.id;
			let this_ = this;
			let toPage = 3;
			if (toPageParam!=null && toPageParam!=undefined) {
				toPage = toPageParam;
			}

			
			let data = { 
				"pickingForDeliveryId": this.modelId,
				"qrCode": qrCode,
			};

			await this.$http.post('PickingForDelivery/ScanDeliveryInstructionItem',data)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					// console.log('ScanDeliveryInstructionItem',response.data);
					this_.setVwPickingDetail(response.data);
					this_.isBusy = false;
					let result = response.data;
					this_.goToNext(toPage, this_.model);
					return;
				}
				this_.toast({message: 'Delivery Instruction Item tidak ditemukan !(1)', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				this_.isBusy = false;
				// console.log(error)
				var stringError = 'tidak ditemukan Delivery Instruction Item !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
			});
			this.isScanDeliveryInstructionItemLoading = false;
			this.inputQrCodeDetail='';
			this.isBusy = false;
			// console.log('masuk router replace')
			// this.getVwPickingForDeliveryDetail();
			// this.inputQrCode = null;
			// this.inputQrCodeDetail = null;

			return true;
		},
		async scanDeliveryInstruction(toPageParam) {
			this.isBusy = true;
			let qrCode = encodeURIComponent(this.inputQrCode);
			this.isScanDeliveryInstructionLoading = true;
			let id = this.model.id;
			// console.log(model);
			let this_ = this;
			let toPage = 2;
			if (toPageParam!=null && toPageParam!=undefined) {
				toPage = toPageParam;
			}
			if (qrCode==this.model.deliveryInstructionDiNumber || this.inputQrCode == this.model.deliveryInstructionDiNumber) {
				this.isBusy = false;
				return this.goToNext(toPage, this.model);
			}
			let isValidDI = false;
			let data = { "qrCode": qrCode };
			await this.$http.post('PickingForDelivery/ScanDeliveryInstruction',data)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					let result = response.data;
					if (result!=null && result!=undefined) {
						isValidDI = true;
						this_.setModel(result);
						this_.isBusy = false;
						return;
					}
				}
				this_.toast({message: 'Delivery Instruction not found !(1)', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				// console.log(error)
				var stringError = 'tidak ditemukan Delivery Instruction !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
						this.isBusy = false;
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
			});
			// console.log('masuk router replace =>', this.modelId)

			this.$router.replace('/pickingfordelivery/scan/' + this.modelId, async() => {

				// console.log('sebelum delete data');
				if (this.modelIdOld) {
					// await PickingForDelivery.deleteData(this,this.modelIdOld);
				}

				return;
			}
			);
			this.$nextTick(() => {
				if (isValidDI) {
					// await PickingForDelivery.deleteData(this,this.modelIdOld);
					this.goToNext(toPage, this.model);
				}
			})
			this.getVwPickingForDeliveryDetail();
			// this.focusScanDeliveryInstructionDetail();
			this.isScanDeliveryInstructionLoading = false;
			this.inputQrCode = '';
			this.inputQrCodeDetail = '';
			this.isBusy = false;

		},
		
		setModel(model){
			// console.log('setModel',model)
			if (this.modelId!=model.id) {
				this.modelIdOld = this.modelId;
			}
			this.modelId = model.id;
			this.model = model;
		},
		
		goToNext(page, item) {
			this.resetFocusScan();
			this.scanPageIndex = page;
			// console.log('goToNext() => page =',page)

			// console.log('this.scanPageIndex',this.scanPageIndex);
			let name = "x";
			if (page==1) {
				this.$nextTick(() => {
					this.focusScanDeliveryInstruction();
				})
			}else if (page==2) {
				this.$nextTick(() => {
					this.focusScanDeliveryInstructionDetail();
				})
				this.getVwPickingForDeliveryDetail();
				// name='fieldset-delivery-instruction-item';
				// this.focusInput(this, name);
			}else if (page==3) {
				this.focusScanDeliveryCard()
			}
			// if(page == 2) {
			// 	this.PickingForDeliveryId = item.id;
			// 	this.modelPickingForDelivery = item;
			// 	this.isShowPopupPickingForDelivery = true;
			// 	return;
			// }

		},
		// isFocusScanDeliveryInstruction :false,
		// isFocusScanDeliveryInstructionItem :false,
		// isFocusScanDeliveryCard :false,
		// isFocusScanCaseSource :false,
		resetFocusScan(){
			this.isFocusScanDeliveryInstruction = true;
			this.isFocusScanDeliveryInstructionItem = false;
			this.isFocusScanCaseSource = false;
			this.isFocusScanDeliveryCard = false;
		},
		focusScanDeliveryInstruction(){
			this.isFocusScanDeliveryInstruction = true;
			this.isFocusScanDeliveryInstructionItem = false;
			
			this.isFocusScanCaseSource = false;
			this.isFocusScanDeliveryCard = false;
			return;
			var name = "fieldset-delivery-instruction";
			this.focusInput(this, name);
		},
		focusScanDeliveryInstructionDetail(){
			this.isFocusScanDeliveryInstruction = false;
			this.isFocusScanDeliveryInstructionItem = true;
			this.isFocusScanCaseSource = false;
			this.isFocusScanDeliveryCard = false;
			return;
			var name ='fieldset-delivery-instruction-item';
			this.focusInput(this, name);
		},
		focusScanDeliveryCard(){
			this.isFocusScanDeliveryInstruction = false;
			this.isFocusScanDeliveryInstructionItem = false;
			this.isFocusScanCaseSource = false;
			this.isFocusScanDeliveryCard = true;
			return;
			var name ='fieldset-scan-delivery-card';
			this.focusInput(this, name);
		},
		focusScanCaseSource(){
			this.isFocusScanDeliveryInstruction = false;
			this.isFocusScanDeliveryInstructionItem = false;
			this.isFocusScanDeliveryCard = false;
			this.isFocusScanCaseSource = true;
			return;
			var name ='fieldset-scan-case-source';
			this.focusInput(this, name);
		}
	},
	beforeMount() {
		this.filterPickingForDelivery = new PickingForDeliveryFilter();
		this.filterPickingForDeliveryDetail = new PickingForDeliveryDetailFilter();
		this.filterPickingCardDetail = new PickingCardDetailFilter();
		//this.getPickingForDeliverys();
		//this.getDeliveryInstructionDetails();
		//this.getPickingForDeliveryDetails();
		//this.getDeliveryInstructionDeliveryCards();
		//this.getControlCards();
		//this.getUserInfos();
		//this.getDeliveryInstructions();
		//this.getPickingStatuss();
	},
	mounted(){
		this.getVwDeliveryInstructions();

		let id = this.$route.params.id;
		// console.log('mounted with id =>',id)
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getPickingForDelivery(id);
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
			
		});
	},
	computed: {
		formattedDeliveryDate() {
			if (this.model.deliveryInstruction && this.model.deliveryInstruction.diDeliveryDate) {
				return moment(this.model.deliveryInstruction.diDeliveryDate).format('DD MMMM YYYY');
			} else {
				return '';
			}
		}
	},
	watch : {
		
		inputQrCode(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getVwDeliveryInstructions(newValue);
			} else {
				this.getVwDeliveryInstructions();
			}
		},
		inputQrCodeDetail(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getVwPickingForDeliveryDetail(newValue);
			} else {
				this.getVwPickingForDeliveryDetail();
			}
		},
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>
